export const SEND_REWARD = "SEND_REWARD";
export const GET_REWARD_HISTORY = "GET_REWARD_HISTORY";
